import { ArticleLinks } from "@aph/ui-lib-humanx";
import { useEffect, useState } from "react";
import { ArticleDetailInterface } from "@/components/ArticlePage/api/interface";
import ArticleSelector from "@/components/ArticlePage/redux/selectors/articleData";
import { useAppSelector } from "@/redux/hooks";
import DeviceSelector from "@/components/ArticlePage/redux/selectors/userAgent";
import { DeviceInfo } from "@/interface/deviceInfo";
import { getPlainTexts } from "@/helpers";
import styles from "./InThisArticle.module.scss";
import { getSlugName } from "@/helpers/getSlugName";

const InThisArticle = (props: {
  hideListDropdown: () => void;
  setIsShowArticleFlyBottom: (d: boolean) => void;
  sectionRefs: any;
  setArticleSectionTitle: (d: string) => void;
  isPharma: boolean;
}) => {
  const { hideListDropdown, sectionRefs, setIsShowArticleFlyBottom, setArticleSectionTitle, isPharma = false } = props;
  const [activeItem, setActiveItem] = useState<string>("");
  const articleInfoObject: ArticleDetailInterface = useAppSelector(ArticleSelector);
  const articleSections = articleInfoObject?.data?.[0]?.attributes?.ArticleContent;

  const inThisArticleObjects = articleSections?.filter((item: any) => item.ComponentType === "ContentTitleDescription");

  const deviceType: DeviceInfo = useAppSelector(DeviceSelector);

  const tableLinks = inThisArticleObjects?.map((item: any) => {
    const itemId = item.id;

    return {
      label: getPlainTexts(item?.Heading),
      id: item.id,
      onClick: () => handleClick(itemId),
      slug: `#${getSlugName(item?.Heading)}`,
    };
  });

  const handleClick = (id: string) => {
    setActiveItem(id);
    hideListDropdown();

  };

  // Use Intersection Observer to track section visibility
  useEffect(() => {
    if (!inThisArticleObjects) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Extract the ID from the intersecting element
            const id = entry.target.id.replace("table-item-", "");
            const targetElement = sectionRefs?.current[`table-item-${id}`];
            const sectionTitle = targetElement.querySelector(`#table-item-title-${id}`)?.textContent || "";
            // Update active item and bottom card visibility
            setActiveItem(id);
            setIsShowArticleFlyBottom(true);
            setArticleSectionTitle(sectionTitle);
          }
        });

        // Check if any section is intersecting
        const anySectionVisible = entries.some((entry) => entry.isIntersecting);

        if (!anySectionVisible) {
          setIsShowArticleFlyBottom(false);
          setActiveItem("");
        }
      },
      {
        root: null, // Use the viewport as the root
        threshold: 0.5, // Trigger as soon as any part of the element is visible
      }
    );

    // Observe all section elements
    inThisArticleObjects.forEach((item: any) => {
      const element = sectionRefs?.current[`table-item-${item.id}`];
      if (element) observer.observe(element);
    });

    return () => {
      observer.disconnect();
    };
  }, [inThisArticleObjects]);

  return (
    <>
      <ArticleLinks
        title="In this article"
        articleList={tableLinks}
        activeItem={activeItem}
        clasName={styles.articleIndex}
      />
    </>
  );
};

export default InThisArticle;
